var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/element-dialog-names.ts
var init_element_dialog_names = __esm({
  "src/element-dialog-names.ts"() {
    "use strict";
  }
});

// src/player-actions.ts
import { PlayerActions as BasePlayerActions } from "@nrk/player-elements/src/player/player-element.js";
var PlayerActions;
var init_player_actions = __esm({
  "src/player-actions.ts"() {
    "use strict";
    PlayerActions = {
      ...BasePlayerActions,
      DialogHide: "player.dialogHide",
      DialogShow: "player.dialogShow"
    };
  }
});

// src/dh-article-player-events.ts
function createDhArticlePlayerEvent(type, detail) {
  return new CustomEvent(type, { bubbles: true, detail });
}
function isDhArticlePlayerEvent(event, eventType) {
  return isTypedCustomEventDetail(event, eventType);
}
function isTypedCustomEventDetail(event, eventType) {
  return event.type === eventType;
}
var init_dh_article_player_events = __esm({
  "src/dh-article-player-events.ts"() {
    "use strict";
  }
});

// src/volume-element.ts
import { html as html4, render as render2 } from "@popeindustries/lit/html.js";
import { nrkMediaVolume1, nrkMediaVolume2 as nrkMediaVolume22, nrkMediaVolume3, nrkMediaVolumeMuted as nrkMediaVolumeMuted2 } from "@nrk/core-icons";
import platform from "@nrk/player-elements/src/utils/platform.js";
import { unsafeHTML as unsafeHTML3 } from "@popeindustries/lit/directives/unsafe-html.js";
import { VolumeElement } from "@nrk/player-elements/src/volume/volume-element.js";
var DhArticleVolumeElement;
var init_volume_element = __esm({
  "src/volume-element.ts"() {
    "use strict";
    init_player_actions();
    DhArticleVolumeElement = class extends VolumeElement {
      static get reactiveAttributes() {
        return {
          ...super.reactiveAttributes,
          simple: Boolean
        };
      }
      /** Attribute flag indicating simple layout mode */
      simple = false;
      updated(changedProperties) {
        super.updated(changedProperties);
        if (!this.isConnected) {
          return;
        }
        render2(this.render(), this, { host: this });
      }
      render() {
        return html4`
      <button
        class="${`dh-article-player-volume__mute absolute top left dh-article-player-focus-ring${this.simple ? "--outside" : ""}`} ${!this.simple ? "center-content" : ""}"
        action="${PlayerActions.ToggleMute}"
        type="mute-button"
        aria-label="${this.muted ? "Lyd p\xE5" : "Lyd av"}"
      >
        ${unsafeHTML3(this.selectIcon())} ${this.renderLabel()}
      </button>
      ${this.renderSlider()}
    `;
      }
      renderLabel() {
        if (!this.simple) {
          return;
        }
        return html4` <span>${this.muted ? "Sl\xE5 p\xE5 lyd" : "Sl\xE5 av lyd"}</span> `;
      }
      renderSlider() {
        if (this.simple || platform.isMobile) {
          return;
        }
        const sliderProgress = this.muted ? 0 : this.volume * 100;
        return html4`
      <div
        class="dh-article-player-volume__control dh-article-player-focus-ring absolute bottom left"
        @mouseleave="${this.handleMouseLeave}"
      >
        <input
          class="dh-article-player-volume__input absolute reset-input-range"
          action="${PlayerActions.SetVolume}"
          type="range"
          min="0"
          max="100"
          step="10"
          aria-label="Juster lydnivå"
          .value="${this.muted ? 0 : this.volume * 100}"
        />
        <div class="dh-article-player-volume__slider absolute" aria-hidden="true">
          <div class="dh-article-player-volume__slider-fill" style="height: ${sliderProgress}%;"></div>
          <div class="dh-article-player-volume__slider-thumb-track">
            <div class="dh-article-player-volume__slider-thumb absolute" style="bottom: ${sliderProgress}%;"></div>
          </div>
        </div>
      </div>
    `;
      }
      handleMouseLeave(_event) {
        if (!this.player.focusVisible && this.focusWithin) {
          this.children[0].focus();
        }
      }
      selectIcon() {
        if (this.muted || this.volume == 0) {
          return nrkMediaVolumeMuted2;
        } else if (this.volume <= 0.33) {
          return nrkMediaVolume1;
        } else if (this.volume > 0.33 && this.volume <= 0.66) {
          return nrkMediaVolume22;
        } else if (this.volume > 0.66) {
          return nrkMediaVolume3;
        }
      }
    };
  }
});

// src/scrubber-element.ts
import { html as html5, render as render3 } from "@popeindustries/lit/html.js";
import { ScrubberElement } from "@nrk/player-elements/src/scrubber/scrubber-element.js";
var DhArticleScrubberElement;
var init_scrubber_element = __esm({
  "src/scrubber-element.ts"() {
    "use strict";
    init_player_actions();
    DhArticleScrubberElement = class extends ScrubberElement {
      readyCallback() {
        render3(this.render(), this, { host: this });
        super.readyCallback();
      }
      updating(propName, oldValue) {
        if (propName === "playheadPosition") {
          if (!this.width) {
            this.width = this.offsetWidth;
          }
        }
        super.updating(propName, oldValue);
      }
      render() {
        return html5`
      <input
        class="dh-article-player-scrubber__input absolute reset-input-range"
        action="${PlayerActions.SeekTo}"
        action:events="change"
        type="range"
        min="0"
        max="100"
        step="1"
        aria-label="Spol"
      />
      <div class="dh-article-player-scrubber__progressbar" type="progressbar" aria-hidden="true">
        <div class="dh-article-player-scrubber__playhead" type="playhead"></div>
        <div class="dh-article-player-scrubber__progressbar--full" type="progressbar-full"></div>
        <div class="dh-article-player-scrubber__progressbar--played" type="progressbar-played"></div>
      </div>
    `;
      }
    };
  }
});

// src/play-pause-button.ts
import { html as html6 } from "@popeindustries/lit/html.js";
import { nrkMediaPause, nrkMediaPlay as nrkMediaPlay2, nrkReload } from "@nrk/core-icons";
import { unsafeHTML as unsafeHTML4 } from "@popeindustries/lit/directives/unsafe-html.js";
function PlayPauseButton(isPlaying, isEnded = false) {
  return html6`
    <button
      class="dh-article-player-playpause-button dh-article-player-button-small dh-article-player-focus-ring center-content absolute"
      action="${PlayerActions.TogglePlay}"
      type="playpause-button"
      aria-label="${isPlaying ? "Pause" : "Spill av"}"
    >
      ${unsafeHTML4(isPlaying ? nrkMediaPause : isEnded ? nrkReload : nrkMediaPlay2)}
    </button>
  `;
}
var init_play_pause_button = __esm({
  "src/play-pause-button.ts"() {
    "use strict";
    init_player_actions();
  }
});

// src/subtitle-button.ts
import { html as html7 } from "@popeindustries/lit/html.js";
import { nrkMediaSubtitles, nrkMediaSubtitlesActive } from "@nrk/core-icons";
import { unsafeHTML as unsafeHTML5 } from "@popeindustries/lit/directives/unsafe-html.js";
function SubtitleButton(subtitlesState, isPlaying) {
  if (!subtitlesState || !subtitlesState.subtitles.length) {
    return;
  }
  return html7`<button
    class="dh-article-player-subtitle-button dh-article-player-button-small dh-article-player-focus-ring center-content absolute"
    action="${PlayerActions.ToggleSubtitles}"
    value="subtitles"
    type="subtitle-button"
    aria-label="${subtitlesState.isShowing ? "Sl\xE5 av Undertekster" : "Sl\xE5 p\xE5 undertekster"}"
    ?playing="${isPlaying}"
  >
    ${unsafeHTML5(subtitlesState.isShowing ? nrkMediaSubtitlesActive : nrkMediaSubtitles)}
  </button>`;
}
var init_subtitle_button = __esm({
  "src/subtitle-button.ts"() {
    "use strict";
    init_player_actions();
  }
});

// src/controls-element.ts
import { html as html8, render as render4 } from "@popeindustries/lit/html.js";
import { ControlsElement } from "@nrk/player-elements/src/controls/controls-element.js";
import { safeCEDefine } from "@nrk/player-elements/src/utils/safe-ce-define.js";
var DhArticleControlsElement;
var init_controls_element = __esm({
  "src/controls-element.ts"() {
    "use strict";
    init_volume_element();
    init_scrubber_element();
    init_play_pause_button();
    init_subtitle_button();
    safeCEDefine("dh-article-player-scrubber", DhArticleScrubberElement);
    safeCEDefine("dh-article-player-volume", DhArticleVolumeElement);
    DhArticleControlsElement = class extends ControlsElement {
      updated(changedProperties) {
        super.updated(changedProperties);
        if (!this.isConnected) {
          return;
        }
        render4(this.render(), this, { host: this });
      }
      render() {
        return html8`
      <div class="dh-article-player-controls__bar">
        <div class="flex">
          <dh-article-player-scrubber
            class="-scrubber dh-article-player-controls__scrubber"
            active="true"
          ></dh-article-player-scrubber>
        </div>
        <div class="dh-article-player-controls__buttons relative">
          ${this.renderVolume()} ${SubtitleButton(this.subtitleState, this.isPlaying)}
          ${PlayPauseButton(this.isPlaying, this.isEnded)}
        </div>
      </div>
    `;
      }
      renderVolume() {
        return html8`<dh-article-player-volume
      class="-volume dh-article-player-controls__volume absolute"
    ></dh-article-player-volume>`;
      }
    };
  }
});

// src/element-dialog-mixin.ts
function DialogMixin(Base) {
  return class extends Base {
    /** Description text to be spoken on dialog visibility */
    accessibleDescription = "";
    // Allow this element to be source of change events that trigger player actions
    action = "";
    /** Enables hiding dialog on click */
    closable = true;
    /** Dialog name used during player action resolution */
    name = "";
    /** The PlayerElement parent instance */
    player;
    value = "";
    _previousActiveElement = null;
    updating(propName, oldValue) {
      if (propName === "hidden" && this.hidden === false) {
        this._previousActiveElement = document.activeElement || this.player;
      }
      super.updating(propName, oldValue);
    }
    updated(changedProperties) {
      super.updated && super.updated(changedProperties);
      if (!this.isConnected) {
        return;
      }
      if (changedProperties.has("hidden")) {
        if (!this.hidden) {
          this.addEventListener("click", this, true);
          document.addEventListener("keydown", this, true);
          if (this.accessibleDescription) {
            const action = this.action;
            this.action = PlayerActions.Speak;
            this.value = this.accessibleDescription;
            this.dispatchEvent(new Event("change", { cancelable: true, bubbles: true }));
            this.action = action;
          }
        } else {
          this._previousActiveElement?.focus({
            preventScroll: true
          });
          document.removeEventListener("keydown", this, true);
        }
      }
    }
    handleEvent(event) {
      let shouldDispatchHide = false;
      if (event.type === "keydown") {
        const keyCode = event.which;
        if (keyCode === 9) {
          document.addEventListener("blur", this, true);
        } else if (keyCode === 27) {
          shouldDispatchHide = true;
        }
      } else if (event.type === "blur") {
        document.removeEventListener("blur", this, true);
        if (!this.contains(event.relatedTarget)) {
          shouldDispatchHide = true;
        }
      } else if (event.type === "click" && event.target === this && this.closable) {
        shouldDispatchHide = true;
      }
      if (shouldDispatchHide) {
        this.hide();
      }
      super.handleEvent && super.handleEvent(event);
    }
    hide() {
      this.action = PlayerActions.DialogHide;
      this.value = this.name;
      this.dispatchEvent(new Event("change", { cancelable: true, bubbles: true }));
    }
    disconnectedCallback() {
      document.removeEventListener("keydown", this, true);
      document.removeEventListener("blur", this, true);
      this.removeEventListener("click", this, true);
      this._previousActiveElement = null;
      super.disconnectedCallback && super.disconnectedCallback();
    }
  };
}
var init_element_dialog_mixin = __esm({
  "src/element-dialog-mixin.ts"() {
    "use strict";
    init_player_actions();
  }
});

// src/error-message-element.ts
import { ReactiveElement } from "@nrk/reactive-element";
import { html as html9, render as render5 } from "@popeindustries/lit/html.js";
import { PlaybackSessionError } from "@nrk/player-core/types.js";
import { PlayerErrorTypes } from "@nrk/player-elements/src/player/player-error.js";
var ERROR_MAPPINGS, DhArticleErrorMessageElement;
var init_error_message_element = __esm({
  "src/error-message-element.ts"() {
    "use strict";
    init_element_dialog_mixin();
    init_element_dialog_names();
    ERROR_MAPPINGS = {
      default: {
        interactive: false,
        message: "Noe gikk galt under avspillingen."
      },
      "404 500": {
        interactive: false,
        message: "Klarte ikke spille av klippet."
      }
    };
    DhArticleErrorMessageElement = class extends DialogMixin(ReactiveElement) {
      static get reactiveProperties() {
        return {
          error: Object
        };
      }
      accessibleDescription = "Noe gikk galt under avspilling";
      closable = false;
      error;
      hidden = true;
      name = "error" /* Error */;
      updating(propName, _oldValue) {
        if (propName === "error" && this.error) {
          this.accessibleDescription = this.getErrorObject(this.error).message;
        }
      }
      updated(changedProperties) {
        super.updated(changedProperties);
        if (!this.isConnected) {
          return;
        }
        if (!this.hidden && this.error) {
          render5(this.render(), this, { host: this });
        }
      }
      getErrorObject(error) {
        if (error instanceof PlaybackSessionError) {
          return this.mapCoreErrorToObject(error);
        }
        return this.mapErrorToObject(error);
      }
      render() {
        return html9` <div class="dh-article-player-errormessage__inner">${this.renderErrorMessage(this.error)}</div> `;
      }
      renderErrorMessage(error) {
        const errorObject = this.getErrorObject(error);
        return html9`
      <span>${errorObject.message}</span>
      ${errorObject.interactive ? html9`<button>Prøv igjen</button>` : ``}
    `;
      }
      mapErrorToObject(error) {
        let { interactive, message } = ERROR_MAPPINGS["default"];
        for (const key in ERROR_MAPPINGS) {
          const { interactive: errorInteractive, message: errorMessage } = ERROR_MAPPINGS[key];
          if (error.code === key || String(error.status) === key || key.includes(String(error.status)) || error.message?.includes(key)) {
            interactive = errorInteractive;
            message = errorMessage;
            break;
          }
        }
        return {
          interactive,
          message
        };
      }
      mapCoreErrorToObject(error) {
        const interactive = false;
        let message = error.message;
        switch (error.type) {
          case PlayerErrorTypes.PLAYBACK_STOPPED_DECODE_ERROR:
          case PlayerErrorTypes.NO_PLAYBACK_DECODE_ERROR:
            message = "Det oppstod en feil.";
            break;
          case PlayerErrorTypes.PLAYBACK_STOPPED_NETWORK_ERROR:
          case PlayerErrorTypes.NO_PLAYBACK_NETWORK_ERROR:
            message = "Avspilling gikk galt p\xE5 grunn av nettverket.";
            break;
          case PlayerErrorTypes.UNSUPPORTED_FORMAT_ERROR:
            message = "Nettleseren din st\xF8tter ikke avspilling av innholdet. Pr\xF8v en annen nettleser.";
            break;
          case PlayerErrorTypes.UNKNOWN_ERROR:
            message = "Det oppsto en ukjent feil.";
            break;
        }
        return {
          interactive,
          message
        };
      }
    };
  }
});

// src/subtitles-element.ts
import { html as html10, render as render6 } from "@popeindustries/lit/html.js";
import { styleMap } from "@popeindustries/lit/directives/style-map.js";
import { SubtitlesElement } from "@nrk/player-elements/src/subtitles/subtitles-element.js";
var DhArticleSubtitlesElement;
var init_subtitles_element = __esm({
  "src/subtitles-element.ts"() {
    "use strict";
    DhArticleSubtitlesElement = class extends SubtitlesElement {
      static get reactiveProperties() {
        return {
          ...super.reactiveProperties,
          isStarted: Boolean
        };
      }
      /** Flag indicating that media playback has started (shadowed Player property) */
      isStarted = false;
      // Default to left-aligned subtitles (5% from bottom edge)
      cueConfig = {
        defaultToIndentedStartAlignment: true,
        indentation: 0
        // lineMargin: 5,
      };
      _unshadowProperties2;
      connectedCallback() {
        super.connectedCallback();
        this._unshadowProperties2 = this.player.shadowProperties(["isStarted"], this);
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this._unshadowProperties2?.();
      }
      updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isStarted") && this.isStarted) {
          this.updateRenderingArea();
        }
        if (this.isConnected && changedProperties.has("subtitleState") && this.subtitleState) {
          render6(this.render(), this, { host: this });
        }
      }
      render() {
        if (!this.isRenderingEnabled() || !this.subtitleState?.activeCues.length) {
          return void 0;
        }
        return html10`${this.subtitleState.activeCues.map((cue, index) => {
          const position = this.activeCuePositions[index];
          return html10`<div class="subtitle__cue" style=${styleMap(position.styles)}>
        ${Array(position.insertLineBreaks).fill(html10`<br />`)}
        <span class="subtitle__text">${cue.getCueAsHTML()}</span>
        ${Array(position.appendLineBreaks).fill(html10`<br />`)}
      </div>`;
        })}`;
      }
      updateRenderingArea() {
        if (this.playerAspectRatio === void 0 || this.videoAspectRatio === void 0) {
          return;
        }
        const supportsCSSMathFunctions = CSS && CSS.supports && CSS.supports("width", "max(1px, 2px)");
        const controlsHeight = this.controls?.clientHeight ?? 0;
        const { top = "0px", right = "0px", bottom = "0px", left = "0px" } = this.getBlackBars();
        if (supportsCSSMathFunctions) {
          this.style.top = top;
          this.style.right = `max(${right}, var(--dh-article-player-margin))`;
          this.style.bottom = `max(${bottom}, ${controlsHeight}px)`;
          this.style.left = `max(${left}, var(--dh-article-player-margin))`;
        } else {
          this.style.top = top;
          this.style.right = right;
          this.style.bottom = bottom;
          this.style.left = left;
        }
      }
      get controls() {
        return this.player?.querySelector(".-controls");
      }
    };
  }
});

// src/tracking-element.ts
import { TrackingElement } from "@nrk/player-elements/src/tracking/tracking-element.js";
var DhArticleTrackingElement;
var init_tracking_element = __esm({
  "src/tracking-element.ts"() {
    "use strict";
    init_dh_article_player_events();
    DhArticleTrackingElement = class extends TrackingElement {
      readyCallback() {
        super.readyCallback();
        if (!this.player) {
          return;
        }
        this.player.addEventListener("player.autoplay" /* Autoplay */, this);
      }
      handleEvent(event) {
        super.handleEvent(event);
        this.handleDhArticlePlayerEvent(event);
      }
      handleDhArticlePlayerEvent(event) {
        if (isDhArticlePlayerEvent(event, "player.autoplay" /* Autoplay */)) {
          this.autoplay = event.detail.isAutoplay;
        }
      }
      disconnectedCallback() {
        this.player?.removeEventListener("player.autoplay" /* Autoplay */, this);
        super.disconnectedCallback();
      }
    };
  }
});

// src/player-element-dependencies.ts
var player_element_dependencies_exports = {};
__export(player_element_dependencies_exports, {
  ConfiguredAdapter: () => ConfiguredAdapter,
  HlsJsAdapter: () => HlsJsAdapter,
  NativeAdapter: () => NativeAdapter,
  PlayerCore: () => PlayerCore
});
import { KeyboardElement } from "@nrk/player-elements/src/keyboard/keyboard-element.js";
import { safeCEDefine as safeCEDefine2 } from "@nrk/player-elements/src/utils/safe-ce-define.js";
import { PlayerCore, ConfiguredAdapter } from "@nrk/player-core/session";
import { HlsJsAdapter } from "@nrk/player-core/adapter-hlsjs.js";
import { NativeAdapter } from "@nrk/player-core/adapter-native.js";
var init_player_element_dependencies = __esm({
  "src/player-element-dependencies.ts"() {
    "use strict";
    init_controls_element();
    init_error_message_element();
    init_subtitles_element();
    init_tracking_element();
    safeCEDefine2("dh-article-player-controls", DhArticleControlsElement);
    safeCEDefine2("dh-article-player-errormessage", DhArticleErrorMessageElement);
    safeCEDefine2("dh-article-player-keyboard", KeyboardElement);
    safeCEDefine2("dh-article-player-tracker", DhArticleTrackingElement);
    safeCEDefine2("dh-article-player-subtitles", DhArticleSubtitlesElement);
  }
});

// src/auto-playback-state.ts
import { TypeState } from "typestate";
function getAutoPlaybackState(props) {
  const { attemptPlay, attemptPause, pauseIntersection, disableAutopause, playIntersection, initialState } = props;
  const state = new TypeState.FiniteStateMachine(initialState);
  state.from("AwaitingIntersection" /* AwaitingIntersection */).to("Playing" /* Playing */, "Paused" /* Paused */, "ManualPlaying" /* ManualPlaying */);
  state.from("Playing" /* Playing */).to("Paused" /* Paused */, "ManualPause" /* ManualPause */);
  state.from("ManualPlaying" /* ManualPlaying */).to("ManualPause" /* ManualPause */);
  if (disableAutopause === false) {
    state.from("ManualPlaying" /* ManualPlaying */).to("Paused" /* Paused */);
  }
  state.from("ManualPause" /* ManualPause */).to("ManualPlaying" /* ManualPlaying */);
  state.from("Paused" /* Paused */).to("AwaitingIntersection" /* AwaitingIntersection */, "ManualPlaying" /* ManualPlaying */);
  const { playGuard, pauseGuard } = getTransitionGuards({ playIntersection, pauseIntersection });
  state.onEnter("Playing" /* Playing */, playGuard);
  state.onEnter("Paused" /* Paused */, pauseGuard);
  let playResult = Promise.resolve();
  const handlePlay = async () => {
    await sleep(250);
    if (state.is("Playing" /* Playing */)) {
      playResult = attemptPlay();
    } else if (state.is("Paused" /* Paused */)) {
      state.go("AwaitingIntersection" /* AwaitingIntersection */);
    }
  };
  state.on("Playing" /* Playing */, handlePlay);
  const handlePause = async () => {
    try {
      await playResult;
    } catch {
    } finally {
      await attemptPause();
    }
  };
  state.on("Paused" /* Paused */, handlePause);
  return state;
}
function handleIsPlayingChange(state, isPlaying) {
  if (isPlaying) {
    if (state.canGo("ManualPlaying" /* ManualPlaying */)) {
      state.go("ManualPlaying" /* ManualPlaying */);
    }
  } else {
    if (state.canGo("ManualPause" /* ManualPause */)) {
      state.go("ManualPause" /* ManualPause */);
    }
  }
}
function handleIntersectionChange(state, entry) {
  if (state.canGo("Playing" /* Playing */)) {
    state.go("Playing" /* Playing */, entry);
  } else if (state.canGo("Paused" /* Paused */)) {
    state.go("Paused" /* Paused */, entry);
  }
}
function sleep(ms) {
  return new Promise((res) => {
    setTimeout(res, ms);
  });
}
function getTransitionGuards({ pauseIntersection, playIntersection }) {
  return {
    pauseGuard: pauseGuardHelper.bind(null, pauseIntersection),
    playGuard: playGuardHelper.bind(null, playIntersection)
  };
}
function pauseGuardHelper(pauseIntersection, _from, { isIntersecting = false, intersectionRatio = 0 } = {}) {
  const canEnterPause = !isIntersecting || pauseIntersection >= intersectionRatio;
  return canEnterPause;
}
function playGuardHelper(playIntersection, _from, { isIntersecting = true, intersectionRatio = 1 } = {}) {
  const canEnterPlay = isIntersecting && playIntersection <= intersectionRatio;
  return canEnterPlay;
}

// src/player-element.ts
init_element_dialog_names();
import { canUseHlsJsAdapter, canUseNativeAdapter } from "@nrk/player-core/adapter-support";
import { html as html11, render as render7 } from "@popeindustries/lit/html.js";
import { getActionFromEvent } from "@nrk/player-elements/src/utils/dom.js";
import { ifDefined as ifDefined2 } from "@popeindustries/lit/directives/if-defined.js";
import { IntersectingMixin } from "@nrk/element-intersecting-mixin";

// src/poster-element.ts
import { html as html2, render } from "@popeindustries/lit/html.js";

// src/poster-element-render-helpers.ts
import { html } from "@popeindustries/lit/html.js";
function renderImage(src) {
  if (src) {
    return html`<img class="full" alt src="${src}" />`;
  }
}

// src/poster-element.ts
init_player_actions();
import { PosterElement } from "@nrk/player-elements/src/poster/poster-element.js";
import { ifDefined } from "@popeindustries/lit/directives/if-defined.js";
import { unsafeHTML } from "@popeindustries/lit/directives/unsafe-html.js";
import { nrkMediaPlay, nrkMediaVolume2, nrkMediaVolumeMuted } from "@nrk/core-icons";
import { formatDuration } from "@nrk/player-elements/index.js";
var DhArticlePosterElement = class extends PosterElement {
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.isConnected) {
      return;
    }
    render(this.render(), this, { host: this });
  }
  render() {
    return html2`
      ${renderImage(this.src)}
      <div class="dh-article-player-poster__bar absolute bottom left right flex">
        <div aria-hidden="true" class="dh-article-player-poster__pills">
          ${this.renderDuration()} ${this.renderVolumeStatus()}
        </div>
        <div>${this.renderPlayButton()}</div>
      </div>
    `;
  }
  renderPlayButton() {
    if (!this.availability || !this.availability.available) {
      return;
    }
    const startTimeIndicatorClass = this.isLive ? "" : "dh-article-player-button--start-time-indicator";
    const startAtPercentage = 100 / this.duration * (this.startTime || 0);
    const startTimeAsDegrees = startAtPercentage ? `--startAtDegrees: ${3.6 * startAtPercentage}deg;` : void 0;
    return html2` <button
      class="dh-article-player-poster__icon-play dh-article-player-button-medium dh-article-player-focus-ring--outside relative center-content ${startTimeIndicatorClass}"
      style="${ifDefined(startTimeAsDegrees)}"
      action="${PlayerActions.Play}"
      ?disabled="${this.availability && !this.availability.available}"
      type="play-button"
      aria-label="${this.accessibleDescription}"
    >
      <span class="sr-only">Spill av</span>
      ${unsafeHTML(nrkMediaPlay)}
    </button>`;
  }
  renderDuration() {
    if (!this.isLive && this.duration) {
      return html2` <div class="flex">
        <time class="dh-article-player-poster__pill">${formatDuration(this.duration)}</time>
      </div>`;
    }
  }
  renderVolumeStatus() {
    if (!this.muted) {
      return;
    }
    return html2` <div class="dh-article-player-poster__pill dh-article-player-poster__muted">
      ${unsafeHTML(this.muted ? nrkMediaVolumeMuted : nrkMediaVolume2)}
      <span> Spiller ${this.muted ? "uten" : "med"} lyd</span>
    </div>`;
  }
};

// src/player-element.ts
init_player_actions();
import platform2 from "@nrk/player-elements/src/utils/platform.js";
import { PlayerElement } from "@nrk/player-elements/src/player/player-element.js";
import { PlayerEvents } from "@nrk/player-elements/src/player/player-events.js";
import { safeCEDefine as safeCEDefine3 } from "@nrk/player-elements/src/utils/safe-ce-define.js";

// src/spinner.ts
import { html as html3 } from "@popeindustries/lit/html.js";
import { nrkSpinner } from "@nrk/core-icons";
import { unsafeHTML as unsafeHTML2 } from "@popeindustries/lit/directives/unsafe-html.js";
function Spinner(hidden) {
  return html3`
    <div class="dh-article-player-spinner center" ?hidden="${hidden}">
      <div class="dh-article-player-spinner__icon">${unsafeHTML2(nrkSpinner)}</div>
    </div>
  `;
}

// src/utils/debounce.ts
function debounce(fn, ms) {
  let stopId;
  const debouncedFn = () => {
    clearTimeout(stopId);
    stopId = setTimeout(() => {
      fn();
      debouncedFn.hasRun = true;
    }, ms);
  };
  debouncedFn.hasRun = false;
  debouncedFn.cancel = () => {
    clearTimeout(stopId);
  };
  debouncedFn.reset = () => {
    clearTimeout(stopId);
    debouncedFn.hasRun = false;
  };
  return debouncedFn;
}

// src/player-element.ts
init_dh_article_player_events();
import { unlockMediaElement } from "@nrk/player-core/utils.js";

// src/utils/lerp.ts
function lerp(min, max, t) {
  return (1 - t) * min + t * max;
}
function lerpClamped(min, max, t) {
  const val = lerp(min, max, t);
  return Math.min(max, Math.max(min, val));
}

// src/utils/normalize.ts
function normalize(value, min, max) {
  const norm = (value - min) / (max - min);
  return Math.max(0, Math.min(1, norm));
}

// src/player-element.ts
var DIRTY_PROPERTIES = [
  "activeDialog",
  "activeSession",
  "handledError",
  "isLive",
  "isRealtime",
  "isWaiting",
  "metadata",
  "muted",
  "src",
  "speak"
];
var MIN_PLAYER_SIZE_BREAKPOINT = 375;
var MAX_PLAYER_SIZE_BREAKPOINT = 1e3;
var STOP_BUFFERING_TIMEOUT = 5e3;
var DhArticlePlayerElement = class extends IntersectingMixin(PlayerElement) {
  static get reactiveAttributes() {
    return {
      ...super.reactiveAttributes,
      disableAutopause: Boolean,
      ga: String,
      lazyAutoplay: Boolean,
      buffering: String,
      sourceId: String,
      syncVolume: Boolean
    };
  }
  static get reactiveProperties() {
    return {
      ...super.reactiveProperties,
      activeDialog: String,
      handledError: Object
    };
  }
  static whenDefinedCallback() {
    safeCEDefine3("dh-article-player-poster", DhArticlePosterElement);
  }
  /** Handles both lazyAutoplaying and autoPausing */
  autoPlaybackState;
  /** The currently active dialog name */
  activeDialog;
  /** `true` if autoplay attempt was successful */
  didLazyAutoplay = false;
  /** The current error, if any */
  handledError;
  /** intersectionEntry - added by Intersecting mixin */
  /** isIntersecting - added by Intersecting mixin */
  /** intersectionThreshold - added by Intersecting mixin */
  /** The Google Analytics account ID */
  ga = "UA-3413696-54";
  /** Should autoplay when element comes into view - uses `intersectionThreshold: [play, pause]` as ratios */
  lazyAutoplay = false;
  /** Flag indicating whether user has interacted with the mute/unmute controls */
  muteHadInteraction = false;
  /** The Google Analytics source ID/dimension10 */
  sourceId;
  /** Should not pause when player leaves view. */
  disableAutopause = false;
  playerName = "dh-article-player";
  /** The current version number placeholder replaced at build time */
  playerVersionNumber = "1.1.5";
  /** Decides how buffering should be done */
  buffering = "default";
  /** Prepares to stop buffering after STOP_BUFFERING_TIMEOUT. Enabled by `buffering="conservative"` */
  stopBuffering = debounce(() => {
    if (this.activeSession) {
      this.activeSession.close();
    }
  }, STOP_BUFFERING_TIMEOUT);
  /** Syncs volume and muted changes with other players */
  syncVolume = false;
  /** The poster state deserialised from "posterdata" attribute during ssr rehydration */
  posterData;
  _playerSize;
  connectedCallback() {
    super.connectedCallback();
    const posterDataAttr = this.getAttribute(".posterData");
    if (posterDataAttr) {
      this.posterData = JSON.parse(posterDataAttr);
    }
    const [playIntersection = 0, pauseIntersection = 0] = this.intersectionThreshold || [];
    this.autoPlaybackState = getAutoPlaybackState({
      initialState: "Paused" /* Paused */,
      playIntersection,
      pauseIntersection,
      disableAutopause: this.disableAutopause,
      attemptPlay: () => {
        if (this.isAnotherPlayerPlaying()) {
          return;
        }
        return this.play().then(() => {
          const isPlaying = this.activeSession?.isPlaying() ?? false;
          this.didLazyAutoplay = isPlaying;
          if (isPlaying) {
            this.dispatchEvent(createDhArticlePlayerEvent("player.autoplay" /* Autoplay */, { isAutoplay: isPlaying }));
            this.activeSession?.once(PlayerEvents.PlayingChange, () => {
              this.dispatchEvent(createDhArticlePlayerEvent("player.autoplay" /* Autoplay */, { isAutoplay: false }));
            });
          }
        }).catch(() => {
          this.dispatchEvent(createDhArticlePlayerEvent("player.autoplay" /* Autoplay */, { isAutoplay: false }));
        });
      },
      attemptPause: () => {
        return this.pause();
      }
    });
  }
  async play() {
    if (this.stopBuffering.hasRun) {
      await this.createSession();
    }
    this.stopBuffering.reset();
    return super.play();
  }
  pause() {
    if (this.buffering === "conservative" && this.isLive) {
      this.stopBuffering();
    }
    return super.pause();
  }
  toggleMute() {
    if (!this.volume) {
      this.muted = false;
      this.volume = 1;
    } else {
      this.muted = !this.muted;
    }
  }
  updating(propName, oldValue) {
    if (propName === "activeDialog") {
      if (this.activeDialog !== void 0 && this.isPlaying) {
        this.activeSession?.pause();
      }
    } else if (propName === "isPlaying") {
      if (this.isPlaying) {
        this.activeDialog = void 0;
      }
    } else if (propName === "handledError") {
      if (this.handledError) {
        this.activeDialog = "error" /* Error */;
      } else {
        this.activeDialog = void 0;
      }
    } else if (propName === "dimensions" && this.dimensions) {
      const breakpoint = Math.min(
        MAX_PLAYER_SIZE_BREAKPOINT,
        Math.max(
          MIN_PLAYER_SIZE_BREAKPOINT,
          MIN_PLAYER_SIZE_BREAKPOINT * (this.dimensions.width / this.dimensions.height)
        )
      );
      const size = this.dimensions.width < breakpoint ? "small" : this.dimensions.width < 768 ? "medium" : "large";
      const playerSize = `player-size--${size}`;
      if (playerSize !== this._playerSize) {
        if (this._playerSize) {
          this.classList.remove(this._playerSize);
        }
        this._playerSize = playerSize;
        this.classList.add(this._playerSize);
      }
    } else if (propName === "lazyAutoplay") {
      const state = this.autoPlaybackState;
      if (this.lazyAutoplay && state.is("Paused" /* Paused */)) {
        this.muted = true;
        state.go("AwaitingIntersection" /* AwaitingIntersection */);
      } else if (state.is("AwaitingIntersection" /* AwaitingIntersection */)) {
        state.go("Paused" /* Paused */);
      }
    } else if (propName === "isAudioOnly") {
      const videoEl = this.querySelector("video");
      if (videoEl) {
        if (this.isAudioOnly) {
          videoEl.classList.add("dh-article-player-audio-only");
        } else {
          videoEl.classList.remove("dh-article-player-audio-only");
        }
      }
    }
    super.updating(propName, oldValue);
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.isConnected) {
      return;
    }
    if (this.isBootstrapped && changedProperties.has("src")) {
      this.posterData = void 0;
    }
    if (changedProperties.has("isPlaying")) {
      handleIsPlayingChange(this.autoPlaybackState, this.isPlaying);
    }
    if (changedProperties.has("intersectionEntry") && this.intersectionEntry && this.lazyAutoplay) {
      handleIntersectionChange(this.autoPlaybackState, this.intersectionEntry);
    }
    if (changedProperties.has("muted") && this.isStarted && !this.muteHadInteraction) {
      this.muteHadInteraction = true;
    }
    if (changedProperties.has("volume") || changedProperties.has("muted")) {
      this.syncVolumeWithOtherPlayers();
    }
    for (const prop of DIRTY_PROPERTIES) {
      if (!this.isBootstrapped || changedProperties.has(prop)) {
        return render7(this.render(), this, { host: this });
      }
    }
  }
  handleEvent(event) {
    if (event.defaultPrevented) {
      return;
    }
    const [action, value] = getActionFromEvent(event);
    if (!action) {
      super.handleEvent(event);
      return;
    }
    switch (action) {
      case PlayerActions.DialogHide: {
        if (this.activeDialog !== void 0) {
          event.preventDefault();
          this.activeDialog = void 0;
        }
        break;
      }
      case PlayerActions.DialogShow: {
        event.preventDefault();
        this.activeDialog = value;
        break;
      }
      case PlayerActions.SetVolume: {
        super.handleEvent(event);
        this.muted = this.volume === 0;
        break;
      }
      default:
        super.handleEvent(event);
    }
  }
  handlePanic(error) {
    this.handledError = error;
  }
  /**
   * Determine if this player can play given media type
   */
  canPlayType(mediaType) {
    const supports = platform2.isApple ? [canUseNativeAdapter, canUseHlsJsAdapter] : [canUseHlsJsAdapter, canUseNativeAdapter];
    return supports.some((support) => support(mediaType));
  }
  minRemFontSize = 1.625;
  maxRemFontSize = 2;
  // Start increasing font size
  minRemFontSizeWidth = 590;
  // Stop increasing font size
  maxRemFontSizeWidth = 1024;
  getRemFontSize() {
    const size = lerpClamped(
      this.minRemFontSize,
      this.maxRemFontSize,
      normalize(this.dimensions.width, this.minRemFontSizeWidth, this.maxRemFontSizeWidth)
    );
    return `${size}rem`;
  }
  /**
   * Retrieve @nrk/player-core module and instantiate 'player' instance
   */
  async initPlayerCoreInstance() {
    if (this.player) {
      return;
    }
    const { HlsJsAdapter: HlsJsAdapter2, NativeAdapter: NativeAdapter2, PlayerCore: PlayerCore2, ConfiguredAdapter: ConfiguredAdapter2 } = await Promise.resolve().then(() => (init_player_element_dependencies(), player_element_dependencies_exports));
    const nativeAdapter = new ConfiguredAdapter2(NativeAdapter2);
    const hlsJsAdapter = new ConfiguredAdapter2(HlsJsAdapter2, () => import("hls.js"));
    const adapters = platform2.isApple ? [nativeAdapter, hlsJsAdapter] : [hlsJsAdapter, nativeAdapter];
    this.player = new PlayerCore2(this, adapters);
  }
  /**
   * Checks the DOM for another Player that `isPlaying` or `isWaiting`.
   */
  isAnotherPlayerPlaying() {
    const players = Array.from(document.getElementsByTagName(this.tagName));
    for (const player of players) {
      const notMe = this !== player;
      const playingOrWaiting = player.isPlaying || player.isWaiting;
      if (notMe && playingOrWaiting) {
        return true;
      }
    }
    return false;
  }
  syncVolumeWithOtherPlayers() {
    if (!this.syncVolume) {
      return;
    }
    const players = Array.from(document.getElementsByTagName(this.tagName));
    for (const player of players) {
      if (this !== player) {
        const element = player.querySelector?.("video,audio");
        if (!this.muted && element) {
          unlockMediaElement(element);
        }
        player.volume = this.volume;
        player.muted = this.muted;
      }
    }
  }
  /**
   * Render DOM based on current state.
   *
   * **NOTE**
   * This is only called on initial bootstrap,
   * or after update when at least one property in "DIRTY_PROPERTIES" has changed.
   */
  render() {
    return html11`
      <video aria-hidden="true"></video>
      <span class="visually-hidden" aria-live="polite">${this.speak}</span>
      <dh-article-player-keyboard></dh-article-player-keyboard>
      <dh-article-player-tracker
        gatrackingid="${this.ga}"
        source-id="${ifDefined2(this.sourceId)}"
      ></dh-article-player-tracker>
      <dh-article-player-subtitles
        class="-subtitles dh-article-player-subtitle"
        type="subtitles"
      ></dh-article-player-subtitles>
      <dh-article-player-controls
        ?autofocusable="${!this.autoPlaybackState.is("Playing" /* Playing */)}"
        class="-controls absolute bottom left right"
        type="controls"
        ?hidden="${this.activeSession === void 0 || !this.isLive && this.activeDialog !== void 0}"
      >
      </dh-article-player-controls>
      ${this.renderPoster()} ${this.renderError()} ${Spinner(!this.isWaiting)}
    `;
  }
  renderPoster() {
    const posterData = this.posterData ?? {};
    return html11`
      <dh-article-player-poster
        class="-poster full"
        type="poster"
        src="${ifDefined2(posterData.src)}"
        srcset="${ifDefined2(posterData.srcset)}"
      >
      </dh-article-player-poster>
    `;
  }
  renderError() {
    return html11`
      <dh-article-player-errormessage
        class="dh-article-player-errormessage full"
        .error="${this.handledError}"
        ?hidden="${this.activeDialog !== "error" /* Error */}"
      ></dh-article-player-errormessage>
    `;
  }
};
export {
  DhArticlePlayerElement
};
